import {createSlice} from '@reduxjs/toolkit';

export interface ResponsiveState {
  isMobile: boolean;
}

const initialState: ResponsiveState = {
  isMobile: false,
};

export const responsiveSlice = createSlice({
  name: 'responsive',
  initialState,
  reducers: {
    setIsMobile: state => {
      state.isMobile = true;
    },
    setIsDesktop: state => {
      state.isMobile = false;
    },
  },
});

export const {setIsMobile, setIsDesktop} = responsiveSlice.actions;

export const selectIsMobile = (state: {responsive: ResponsiveState}): boolean =>
  state.responsive.isMobile;

export type responsiveSliceType = typeof responsiveSlice;
export default responsiveSlice.reducer;
